export default __webpack_public_path__ + "static/media/vexos.4b79bce1.png";